module.exports = __webpack_public_path__ + "static/confirm-email-0611d458ee14c104f837530c0e7dc719.png";